/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Helmet } from "react-helmet"
import { useLocalPath } from '../components/hooks/useLocalPath'
import { mapLangSelector, mapLocale } from '../utils/mapping'
import { useDictionaryQuery } from "../fragments/hooks/useDictionaryQuery"
import { useLocation } from '@reach/router';
function Seo({ description, title, children, lang, slug, vanitySlug, image, node_locale, hrefLangs = [], schema = [], content, store }) {
    const { site } = useStaticQuery(
        graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
    )
    const {seoImage} = useDictionaryQuery()
    const location = useLocation()
    const localeSlug = useLocalPath(slug && slug[0] === '/' ? slug.substring(1) : `${slug}`)
    const siteUrl = 'https://www.tazo.com/'
    const newSlug = localeSlug[0] === '/' ? localeSlug.substring(1) : localeSlug
    const finalUrl = vanitySlug ? `${siteUrl}${vanitySlug}/` : siteUrl[siteUrl.length - 1] === '/' ? `${siteUrl}${newSlug}` : `${siteUrl}/${newSlug}`
    // const metaDescription = description || site.siteMetadata.description
    const defaultTitle = site.siteMetadata?.title
   // const { logo } = useSiteQuery()

    let seoImg = seoImage.file.url;
    if (image) {
      seoImg = image.file.url;
    }
    switch (lang) {
        case "us/en":
            lang = "en"
            break
        case "us/es":
            lang = "es"
            break
        case "ca/en":
            lang = "en-CA"
            break
        case "ca/fr":
            lang = "fr"
            break
        default:
            lang = "en"
    }
    return (
        <>
            <Helmet
                htmlAttributes={{
                    lang,
                }}
                title={title}
                titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
            >
                <link rel="canonical" href={finalUrl} />
                { /* <link rel="canonical" href={`https://www.tazo.com${location.pathname}`}></link>  */}
                <meta name="market" content={node_locale} />
                <meta name='description' content={description} />

                <meta property='og:title' content={title} />
                <meta property='og:description' content={description} />
                <meta property='og:image' content={`https:${seoImg}`} />
                <meta property='og:image:secure_url' content={`https://secure.${seoImg.substr(2)}`} />
                <meta property="og:image:type" content="image/jpeg" />
                <meta property="og:image:width" content="400" />
                <meta property="og:image:height" content="300" />
                <meta property="og:image:alt" content="Tazo Teas" />

                <meta name="twitter:card" content="summary" />
                <meta name="twitter:title" content={title} />
                <meta name="twitter:description" content={description} />

                <meta name="ps-language" content={ lang === 'en' ? 'en' : 'es'} /> 
                <meta name="ps-key" content= {store === true ? '6426-6455897706ba60000e0ff4da' : '6426-643d6c84f47cc7000e282f89 '} />
                <meta name="US" content="US" />
                {content ? <meta name="google-site-verification" content='sCG9ZyscID9FExg_rtbZTx-Vsi6_xoonmn7kc3IFUNY' /> : null}
            </Helmet>
            <Helmet>
            <link rel="alternate" hreflang="x-default" href={`https://www.tazo.com${location.pathname}`}></link>
                {
                    hrefLangs.map(({ slug, node_locale }, index) => {
                        return slug === '/'
                            ? node_locale && mapLocale[node_locale] && (<link key={index} rel="alternate" title={mapLangSelector[node_locale]} hrefLang={node_locale} href={`https://www.tazo.com/${mapLocale[node_locale]}/`} />)
                            : slug[slug.length - 1] === '/'
                                ? node_locale && mapLocale[node_locale] && (<link key={index} rel="alternate" title={mapLangSelector[node_locale]} hrefLang={node_locale} href={`https://www.tazo.com/${mapLocale[node_locale]}/${slug}`} />)
                                : node_locale && mapLocale[node_locale] && (<link key={index} rel="alternate" title={mapLangSelector[node_locale]} hrefLang={node_locale} href={`https://www.tazo.com/${mapLocale[node_locale]}/${slug}/`} />)
                    })
                }
                    {schema && (
                        <script type="application/ld+json">{JSON.stringify(schema)}</script>
                    )}
            </Helmet>
        </>
    )
}

Seo.defaultProps = {
    description: ``,
}

Seo.propTypes = {
    description: PropTypes.string,
    title: PropTypes.string.isRequired,
    meta: PropTypes.arrayOf(PropTypes.object),
}

export default Seo
